<script lang="ts">
    export let value: any,
        id: string,
        classList: string = "",
        onChange: (e: Event) => void,
        type:
            | "password"
            | "text"
            | "number"
            | "checkbox"
            | "noInput"
            | "textarea"
            | "checkboxInput"
            | "checkboxInputNumber" = "text",
        placeholder: string = "",
        disabled: boolean = false,
        smallTextarea = false,
        onBlur: (e: Event, valueChanged: boolean) => void = undefined,
        noPadding = false,
        unit = ""

    $: hasValue = Boolean(value)

    const attributes = {
        id,
        class: classList,
        name: id,
        disabled: !!disabled,
    }

    let initialValue: any = value
    let focus = false

    function onBlurFn(e: Event) {
        focus = false
        if (type === "checkboxInput" || type === "checkboxInputNumber") {
            if (!value) {
                const checkbox = document.getElementById(id) as HTMLInputElement
                if (checkbox) checkbox.checked = false
            }
        }
        const valueChanged = initialValue !== value
        if (onBlur) onBlur(e, valueChanged)
        else onChange(e)
    }

    function onFocusFn() {
        focus = true
        initialValue = value
    }
</script>

<label
    style=""
    class="{type}"
    class:textarea="{type == 'textarea'}"
    class:smallTextarea="{smallTextarea}"
    class:noPadding="{noPadding}"
    class:noMinHeight="{type == 'checkbox'}"
>
    {#if type !== "checkbox"}
        <p
            class:checkboxWrapper="{type == 'checkboxInput' || type == 'checkboxInputNumber'}"
            class:hasValue="{hasValue || type === 'noInput' || focus}"
        >
            {placeholder}
        </p>
    {/if}
    {#if type == "checkbox"}
        <div class="checkbox-wrapper">
            <input
                type="checkbox"
                {...attributes}
                on:change="{onChange}"
                bind:checked="{value}"
            />
            <button
                type="button"
                class="checkit-span"
                style="{!placeholder ? 'margin: 0px !important;' : ''}"
                tabindex="{3}"
                on:click="{() => {
                    value = !value
                    setTimeout(() => {
                        const event = new Event('change', { bubbles: true })
                        document.getElementById(id)?.dispatchEvent(event)
                    }, 10)
                }}"
                on:keydown="{(e) => {}}"></button>
            {#if placeholder}
                <span class="content-font">{placeholder}</span>
            {/if}
        </div>
    {/if}
    {#if type == "checkboxInput"}
        <div class="checkbox-wrapper">
            {#key value}
                <input
                    type="checkbox"
                    {...attributes}
                    on:change="{onChange}"
                    on:click="{(e) => {
                        e.preventDefault()
                        if (!value) {
                            e.currentTarget.checked = false
                        }

                        const input = document.getElementById(`${id}-input`)
                        if (input) {
                            // if already focused, blur
                            const event = new Event('change', { bubbles: true })
                            input.dispatchEvent(event)
                            if (!!value) {
                                value = ''
                                input.blur()
                                //trigger on change for input
                            } else input.focus()
                        }
                    }}"
                    checked="{!!value}"
                />
            {/key}
            <button
                type="button"
                class="checkit-span"
                tabindex="{3}"
                on:click="{() => {}}"
                on:keydown="{(e) => {}}"></button>
            <span class="content-font">
                <input
                    on:focus="{onFocusFn}"
                    on:blur="{onBlurFn}"
                    {...attributes}
                    bind:value="{value}"
                    on:change="{onChange}"
                    id="{id}-input"
                /></span
            >
        </div>
    {/if}
    {#if type == "checkboxInputNumber"}
        <div class="checkbox-wrapper">
            <input
                type="checkbox"
                {...attributes}
                on:change="{onChange}"
                on:click="{(e) => {
                    const input = document.getElementById(`${id}-input`)
                    if (input) {
                        if (!!value) {
                            input.blur()
                            value = ''
                        } else input.focus()
                    }
                }}"
                checked="{!!value}"
            />
            <button
                type="button"
                class="checkit-span"
                tabindex="{3}"
                on:click="{() => {}}"
                on:keydown="{(e) => {}}"></button>
            <span class="content-font">
                <input
                    on:focus="{onFocusFn}"
                    on:blur="{onBlurFn}"
                    {...attributes}
                    bind:value="{value}"
                    on:change="{onChange}"
                    id="{id}-input"
                    type="number"
                /></span
            >
            <div class="unit">{unit}</div>
        </div>
    {/if}
    {#if type == "password"}
        <input
            on:focus="{onFocusFn}"
            {...attributes}
            on:blur="{onBlurFn}"
            bind:value="{value}"
            on:change="{onChange}"
        />
    {/if}
    {#if type == "text"}
        <input
            on:focus="{onFocusFn}"
            on:blur="{onBlurFn}"
            {...attributes}
            bind:value="{value}"
            on:change="{onChange}"
        />
    {/if}
    {#if type == "textarea"}
        <textarea
            on:focus="{onFocusFn}"
            on:blur="{onBlurFn}"
            {...attributes}
            bind:value="{value}"
            on:change="{onChange}"></textarea>
    {/if}
    {#if type == "number"}
        <input
            on:focus="{onFocusFn}"
            on:blur="{onBlurFn}"
            type="number"
            {...attributes}
            bind:value="{value}"
            on:change="{onChange}"
        />
        {#if unit}
            <div
                class="unit"
                style="position: absolute; top: 50%;transform: translateY(-50%); right: 0.6rem;"
            >
                {unit}
            </div>
        {/if}
    {/if}
    {#if type == "noInput"}
        <div class="no-input">
            {#if id.includes("pass")}
                ************
            {:else}
                {Boolean(value) ? value : "-"}
            {/if}
        </div>
    {/if}
</label>

<style lang="less">
    label {
        min-height: 54px;
        &.noMinHeight {
            min-height: 0px;
        }
    }
</style>
